import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { SelectBaseComponent } from 'src/app/shared-feature/components/select/select-base';

@Component({
  selector: 'app-appv-select',
  templateUrl: './appv-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => APPaymentSelectComponent),
      multi: true
    }
  ]
})
export class APPaymentSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = ``;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(contains(docCode, '${encodeURIComponent(
        searchStr
      )}') or contains(payTo,'${encodeURIComponent(searchStr)}'))`;
    }
    let url = `api/appayments/query?$expand=currency($select=code)&$top=20&$skip=0&$orderby=docCode asc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}
